import React, { useEffect, useState } from 'react';
import AButton from '../../../../common/form-fields-mui/AButton';
import { Accordion } from "views/pages/manage/common/commonComponents";
import AddEditBankAccountDialog from './AddEditBankAccountDialog';
import BankDetailsCard from './BankDetailsCard';
import PencilIcon from "assets/img/svg/svgComponents/PencilIcon";
import { bankAccountTypes, EMPTY_FORM, getAllBankAccountsByPsid, studentRelationDropdown, useGetDropdownData, userTypes } from './utils';
import { useParams } from "react-router";
import ALoader from '../../../../common/a-loader';
import { REFUND_MANAGE_ACCOUNTS } from '../../constant';
const _ = require("lodash");



const StudentBankDetails = ({source}) => {

    const { psid } = useParams();

    const [studentBankDetails, setStudentBankDetails] = useState([]);

    const [addEditBankDetailsInfo, setAddEditBankDetailsInfo] = useState({});
    const [loading, setLoading] = useState(false);


    const { dropdownData } = useGetDropdownData(setLoading);


    const addNewBankAccount = e => {
        e.stopPropagation();
        setAddEditBankDetailsInfo({
            isOpen: true,
            initialForm: {
                ...EMPTY_FORM,
                psid
            }
        })
    }

    const editAccountDetails = (details) => {

        const { allBanks, allCountries } = dropdownData;
        const accountDetails = _.pick(details, [...Object.keys(EMPTY_FORM), "updatedOn", "updatedBy"])
        const { bankMasterId, country, accountType, bankAccountType, accountRelation } = details;
        
        setAddEditBankDetailsInfo({
            isOpen: true,
            forEdit: true,
            initialForm: {
                psid,
                ...accountDetails,
                bank: allBanks?.find(bank => bank?.value === bankMasterId),
                country: allCountries?.find(el => el?.value === country),
                accountType: userTypes?.find(type => type?.value === accountType),
                bankAccountType: bankAccountTypes?.find(type => type?.value === bankAccountType),
                studentRelation : studentRelationDropdown?.find(rel => rel?.value === accountRelation)
            }
        })
    }

    const getAllBankAccounts = async () => {
        try {
            setLoading(true);
            const data = await getAllBankAccountsByPsid(psid);
            setStudentBankDetails(data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        Object.keys(dropdownData)?.length > 0 && getAllBankAccounts();
    }, [psid, dropdownData]);


    return (

        <>
            {loading && <ALoader position={"fixed"} />}

            <Accordion
                defaultOpen={source === REFUND_MANAGE_ACCOUNTS}
                title={
                    <div className='d-flex justify-content-between align-items-center w-100'>
                        <div className='h3' style={{color : '#262626'}}>
                            Student Bank Details
                        </div>
                        <AButton
                            variant='primary_filled'
                            size='xs'
                            className='mr-2'
                            onClick={addNewBankAccount}
                        >
                            Add a new bank account
                        </AButton>
                    </div>
                }
                titleClasses="w-100 mb-0"
            >

                <AddEditBankAccountDialog
                    dialogInfo={addEditBankDetailsInfo}
                    setDialogInfo={setAddEditBankDetailsInfo}
                    dropdownData={dropdownData}
                    setLoading={setLoading}
                    getAllBankAccounts={getAllBankAccounts}
                    key={JSON.stringify(addEditBankDetailsInfo)}
                />

                <div className='d-flex flex-start flex-wrap' style={{ gap: '0.5rem' }}>
                    {studentBankDetails?.map(details =>
                        <BankDetailsCard
                            key={details?.id}
                            accountDetails={details}
                            iconClickHandler={editAccountDetails}
                            openDetailsDialogIcon={<PencilIcon/>}
                        />
                    )}
                </div>

            </Accordion>
        </>
    );
}

export default StudentBankDetails;